import { Grid2 } from "@mui/material";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import RoleSelectionDialog from "./components/RoleSelectionDialog";
import LeftSection from "./sections/LeftSection";
import RightSection from "./sections/RightSection";

export default function FormPage() {
  const [role, setRole] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(true);
  const navigate = useNavigate();

  const handleRoleSelect = (selectedRole) => {
    if (selectedRole === "therapist") {
      navigate("/therapist");
    } else {
      setRole("patient");
      setDialogOpen(false);
    }
  };
  return (
    <>
      <Grid2
        container
        // spacing={2}
        height={"100vh"}
        // direction="row"
        // sx={{ bgcolor: "#fafafa" }}
        sx={{
          bgcolor: "#fafafa",
          filter: dialogOpen ? "blur(12px)" : "none", // ⬅️ more blur
          pointerEvents: dialogOpen ? "none" : "auto", // block clicks while blurred
          transition: "filter 0.3s ease", // smooth blur animation
        }}
      >
        {/* Left Section */}
        <LeftSection />
        {/* Right Section */}
        <RightSection />
      </Grid2>

      {/* Role Selection */}
      <RoleSelectionDialog open={dialogOpen} onSelect={handleRoleSelect} />
    </>
  );
}
